module.exports = __webpack_public_path__ + "img/bell_dynamic_colour.44f442b8.svg";